(function () {
  function pathMatchesPrefix(pathname, prefix) {
    return prefix === '' || pathname === prefix || pathname.indexOf(prefix + '/') === 0;
  }

  function normalizeUrl(url, requiredPathPrefix) {
    try {
      var parsedUrl = new URL(url, window.location.origin);

      if (
        parsedUrl.origin === window.location.origin
        && requiredPathPrefix
        && !pathMatchesPrefix(parsedUrl.pathname, requiredPathPrefix)
      ) {
        return null;
      }

      if (parsedUrl.origin === window.location.origin) {
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      }

      return parsedUrl.href;
    } catch (error) {
      return null;
    }
  }

  function getAlternateUrl(hreflangList, requiredPathPrefix) {
    var requestedHreflangs = hreflangList
      .split(',')
      .map(function (hreflang) {
        return hreflang.trim().toLowerCase();
      })
      .filter(Boolean);

    if (requestedHreflangs.length === 0) {
      return null;
    }

    var alternateLinks = Array.prototype.slice.call(
      document.querySelectorAll('link[rel="alternate"][hreflang]')
    );

    for (var index = 0; index < requestedHreflangs.length; index += 1) {
      var matchingLinks = alternateLinks.filter(function (link) {
        return link.getAttribute('hreflang').toLowerCase() === requestedHreflangs[index];
      });

      for (var linkIndex = matchingLinks.length - 1; linkIndex >= 0; linkIndex -= 1) {
        var normalizedUrl = normalizeUrl(matchingLinks[linkIndex].href, requiredPathPrefix);

        if (normalizedUrl) {
          return normalizedUrl;
        }
      }
    }

    return null;
  }

  function updateMarketLanguageLinks() {
    var links = document.querySelectorAll('[data-market-language-alternate-link]');

    Array.prototype.forEach.call(links, function (link) {
      var normalizedUrl = getAlternateUrl(
        link.getAttribute('data-market-language-hreflangs') || '',
        link.getAttribute('data-market-language-path-prefix') || ''
      );

      if (normalizedUrl) {
        link.setAttribute('href', normalizedUrl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMarketLanguageLinks);
  } else {
    updateMarketLanguageLinks();
  }

  document.addEventListener('shopify:section:load', updateMarketLanguageLinks);
}());
